import { ChronoUnit, LocalDate } from "@js-joda/core";
import { WorkerEmploymentType } from "model/Salary";
import {
  getStockholmLocalDateNow,
  parseIsoDateToLocalDateOrNull,
} from "web-apps/company/utils/timeAndDate";

export type StaffProbationStatus = "ending" | "ended";

interface StaffProbationStatusInput {
  readonly employmentType: string;
  readonly endDate: string | null | undefined;
}

export function getStaffProbationStatus(
  item: StaffProbationStatusInput,
  today: LocalDate = getStockholmLocalDateNow(),
): StaffProbationStatus | null {
  if (item.employmentType !== WorkerEmploymentType.INTRODUCTORY) return null;

  const endDate = parseIsoDateToLocalDateOrNull(item.endDate);
  if (!endDate) return null;

  const daysUntilEnd = today.until(endDate, ChronoUnit.DAYS);
  if (daysUntilEnd < 0) return "ended";
  if (daysUntilEnd <= 30) return "ending";
  return null;
}
